export const nestedTernaryCheckerCond1 = (cond1: boolean, cond2: boolean, val1: any, val2: any, val3: any) => {
  if (cond1) {
    return cond2 ? val1 : val2;
  }
  return val3;
};
export const nestedTernaryCheckerCond2 = (cond1: boolean, cond2: boolean, val1: any, val2: any, val3: any) => {
  if (cond1) {
    return val1;
  }
  return cond2 ? val2 : val3;
};
export const checkWithLowerCase = (val1: string, val2: string) => {
  const value1 = val1.toLowerCase();
  const value2 = val2.toLowerCase();
  if (value1 === value2) return true;
  return false;
};
